import React from 'react'
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { openLoginModal } from '../features/ModalSlice';

export const Protected = ({ children }) => {
    const user = (sessionStorage.getItem("userData") && (sessionStorage.getItem("userData")))
    const dispatch = useDispatch()
    const funNav = () => {
        toast.error("Please log in to access all the features", {
            autoClose: 1500
        })
        dispatch(openLoginModal())
        return
    }
    if (user === null && !user) {
        funNav()
        return <Navigate to="/" />
    }

    return children
}
